import React, { useState, useEffect, useRef } from 'react';
import { update } from '../../api';
import { v4 as uuid } from 'uuid';
import CustomModal from './CustomModal';
import './DocumentModal.css';

const getInitialState = (document) => ({
  answer: document?.answer || '',
  status: ["Approved", "Expired", "Pending", "Invalid"].includes(document?.status) ? document.status : "Other",
  question: document?.question || '',
  source: document?.source || '',
  tags: document?.tags ? document.tags.join(', ') : ''
});

const DocumentModal = ({ documentModalOpen, closeModal, selectedDocument, setIsLoading, updateDocumentInState }) => {
  const [formData, setFormData] = useState(getInitialState(selectedDocument));

  const answerRef = useRef(null);

  const adjustTextareaHeight = () => {
    if (answerRef.current) {
      answerRef.current.style.height = 'inherit';
      answerRef.current.style.height = `${answerRef.current.scrollHeight}px`;
    }
  };

  useEffect(() => {
    adjustTextareaHeight();
  }, [formData.answer]);

  useEffect(() => {
    setFormData(getInitialState(selectedDocument));
    adjustTextareaHeight();
  }, [selectedDocument]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleSave = async () => {
    closeModal();
    setIsLoading(true);
    const updatedTags = formData.tags.split(',').map(tag => tag.trim()).filter(tag => tag);
    const isAddingNewDocument = !selectedDocument?.id;

    try {
      const updatedDocument = {
        id: isAddingNewDocument ? uuid() : selectedDocument.id,
        ...formData,
        tags: updatedTags
      };
      await update([updatedDocument]);
      updateDocumentInState(updatedDocument, isAddingNewDocument);
    } catch (error) {
      console.error('Error saving document:', error);
    } finally {
      setIsLoading(false);
    }
  };
    
  return (
    <CustomModal
      isOpen={documentModalOpen}
      onClose={closeModal}
      overlayClassName="modal-overlay"
      modalClassName="modal-base"
      headerContent={
        <h3>Edit Document</h3>
      }
      bodyContent={
        selectedDocument && (
          <div>
            <div className="document-modal-row">
              <label>Status</label>
              <select name="status" value={formData.status} onChange={handleInputChange}>
                <option value="Approved">Approved</option>
                <option value="Expired">Expired</option>
                <option value="Pending">Pending</option>
                <option value="Invalid">Invalid</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="document-modal-row">
              <label>Source</label>
              <input name="source" value={formData.source} onChange={handleInputChange} />
            </div>
            <div className="document-modal-row">
              <label>Tags (Comma Separated)</label>
              <input name="tags" value={formData.tags} onChange={handleInputChange} />
            </div>
            <div className="document-modal-row">
              <label>Question</label>
              <textarea name="question" value={formData.question} onChange={handleInputChange} />
            </div>
            <div className="document-modal-row">
              <label>Answer</label>
              <textarea
                ref={answerRef}
                name="answer"
                value={formData.answer}
                onChange={(e) => {
                  handleInputChange(e);
                  adjustTextareaHeight();
                }}
              />
            </div>
          </div>
        )
      }
      footerContent={
        <div>
          <button onClick={handleSave}>Save</button>
          <button onClick={closeModal}>Close</button>
        </div>
      }
    />
  );
};

export default DocumentModal;